module.exports = __webpack_public_path__ + "videos/sync-translation.c45dc18.webm";